var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Raven = function () {
    EHDI.aka.Container.call(this);
};

EHDI.game.Raven.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Raven.prototype.init = function (count) {
  this._animation;

  this._baseSpeed = 0.1;
  this._currentSpeed;
  this._collided = false;

  this.tl1;
  this.tl2;
  this._sfxName;
  this.sfxPlayed = false;

  this.initAnimationPath(count);

  this._hitbox;

  if (this._hitbox == undefined) {
    this._hitbox = new EHDI.game.Hitbox(30, 30, 30, 0, 0x0000ff);

    this.addChild(this._hitbox);
  }

  if (this._animation == undefined) {
    this._animation = new EHDI.game.Animation();
    // if (this._animationPath == 'raven_')
    this._animation.init('birds_anim');
    // else
      // this._animation.('obs_branchandcloth');
    EHDI.GetAnimationFactory().addAnimation('obs_branchandcloth');
  }

  this.removeChild(this._animation.getDisplay());
  this._animation.rebuildArmature(this._animationPath + 'armature');
  this.addChild(this._animation.getDisplay());
};

EHDI.game.Raven.prototype.initAnimationPath = function (count) {
  if (count == 0) {
    this._sfxName = 'spawn_crow';
    this._animationPath = 'raven_';
  }
  else if (count == 1) {
    this._sfxName = 'obstacle_hit';
    this._animationPath = 'branch_';
  }
  else {
    this._sfxName = 'obstacle_hit';
    this._animationPath = 'cloth_';
  }
}

EHDI.game.Raven.prototype.getHitbox = function () {
  return this._hitbox;
};

EHDI.game.Raven.prototype.collided = function () {
  this._collided = true;

  if (this._animationPath == 'raven_') {
    this._animation.changeAnimation2(this._animationPath + 'hit');
    this._animation.play();
  }

  // else
  //   this._animation.changeAnimation2(this._animationPath);

  // this._animation.play();
  EHDI.GAME.soundManager.playSFX('obstacle_hit');

  if (this._animationPath == 'raven_') {
    this.tl1 = gsap.to(this, 1, {x:this.x + 100});
    this.tl2 = gsap.to(this, 1, {y:this.y - 20, ease:Back.easeOut});
  } else {
    this.tl1 = gsap.to(this, 1, {x:this.x + 200});
    this.tl2 = gsap.to(this, 1, {y:this.y + 200, ease:Back.easeIn});
  }

};

EHDI.game.Raven.prototype.reset = function () {
  if (this.tl1 != null) {
    this.tl1.kill();
    this.tl1 = null;
  }

  if (this.tl2 != null) {
    this.tl2.kill();
    this.tl2 = null;
  }
}

EHDI.game.Raven.prototype.start = function (prevLevel) {
  this._currentSpeed = this._baseSpeed;

  var randomLevel = [];

  for (var i = 1; i <= 3; i++) {
    if(i != prevLevel)
      randomLevel.push(i);
  }

  var randomLevelNumber = Math.floor(Math.random() * randomLevel.length);

  this.x = 1200;
  this.y = this.getYPos(randomLevel[randomLevelNumber]);

  if (this._animationPath == 'raven_') {
    this._animation.changeAnimation2(this._animationPath + 'fly');
    this._animation.changeAnimation2(this._animationPath);
  }

  this._animation.play();

  return randomLevel[randomLevelNumber];
};

EHDI.game.Raven.prototype.getYPos = function (lvl) {
  if(lvl == 1)
    return 120;
  else if (lvl == 2)
    return 250;
  else {
    return 380;
  }
}

EHDI.game.Raven.prototype.stop = function () {
  if (this.parent != null)
    this.parent.removeChild(this.parent);

  this._animation.stop();
}

EHDI.game.Raven.prototype.stopAnimation = function () {
  this._animation.stop();
}

EHDI.game.Raven.prototype.playSFX = function () {
  EHDI.GAME.soundManager.playSFX(this._sfxName);
}

EHDI.game.Raven.prototype.update = function (delta, additionalSpeed) {
  if (!this._collided) {
    this.x -= (additionalSpeed + this._currentSpeed) * delta;

    if (!this.sfxPlayed && this.x < 700)
    {
      this.sfxPlayed = true;
      if (this._animationPath == 'raven_')
        this.playSFX();
    }

    this._hitbox.update(this.x, this.y);
  }
};

EHDI.game.Raven.prototype.dispose = function () {
  
  if(this.tl1 != null) this.tl1.kill();
  delete this.tl1;

  if(this.tl2 != null) this.tl2.kill();
  delete this.tl2;
  
  if(this._animation != null)
  {
    this._animation.stop();
    this._animation.reset();
  }
  delete this._animation;

  if(this._hitbox != null)
  {
    this._hitbox.dispose();
  }
  delete this._hitbox;

  this._baseSpeed = null;
  this._currentSpeed = null;
  this._collided = null;

  this._sfxName = null;
  this.sfxPlayed = null;
};
